import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getListSlideDesks, removeSlideDesk } from "@actions";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { Icon } from '@components/common'
import { LoaderText } from "@utils";

//ui-partents
import { MessageEmtyData } from "@ui-partents/Message";
import { BtnIconDeleteV2 } from "@ui-partents/Button";
import { DateFormatter } from "@ui-partents/DateTime";
import { SearchCustomForTable } from "@ui-partents/Search";
import { WrapModalDeleteCommon } from "@ui-partents/Modal";
import Plus from '@images/common/plus-single.svg'

// Import the pagination configuration
import { ButtonComponent } from "@components/patterns/elements/Button";
import {paginationOptions} from "@utils";
import styled from 'styled-components';
import ModalNewExperiment from './ModalNewExperiment';

const WrapFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  .btn-add-new {
    font-weight: 500;
    gap: 4px;
    span {
      white-space: nowrap;
    }
  }
`

const TextDetail = styled.div`
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%; /* 21px */
  color: #0089C2;
`

const ChatbotTable = (props) => {
  const dispatch = useDispatch();
  const listCase = useSelector((state) => state?.getListSlideDesks || []);

  const [modal, setModal] = useState({
    newExperiment: false,
  });

  const toggle = (type) => {
    setModal(prevState => ({ ...prevState, [type]: !prevState[type] }));
  };

  useEffect(() => {
    dispatch(getListSlideDesks({
      action_type: "list_slide_decks"
    }));
  }, [dispatch])

  const columns = [
    {
      dataField: "title",
      text: "Experiment",
      headerClasses: "font-weight-500",
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center">
            <p className='ml-1'>Agent Name</p>
          </div>
        );
      },
    },
    {
      dataField: "updated_at",
      text: "Date Created",
      headerClasses: "font-weight-500",
      formatter: (cell, row) => {
        return (
          <DateFormatter date={cell} format="MMMM Do YYYY, h:mm:ss A" />
        );
      },
    },
    {
      dataField: "ReviewStatus",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <div className={`d-flex align-items-center question-type`}>
            <p>Complete</p>
          </div>
        );
      },
      filterValue: (cell, row) => row.Contents.question
    },
    {
      dataField: "title",
      text: "Experiment",
      headerClasses: "font-weight-500",
      formatter: (cell, row) => {
        return (
          <TextDetail>
            View Details
          </TextDetail>
        );
      },
    },
    {
      dataField: "",
      text: "Action",
      headerClasses: "font-weight-500 text-center",
      headerStyle: { width: "72px" },
      formatter: (cell, row) => {
        return (
          <div className="d-flex align-items-center justify-content-start">
            <WrapModalDeleteCommon
              title={`Delete Presentation`}
              sub={`Are you sure you want to delete this presentation? This action cannot be undone.`}
              handleRemove={handleRemove}
              idRemove={row?.id}
            >
              {({onOpen}) => (
                <BtnIconDeleteV2 handleDelete={onOpen} />
              )}
            </WrapModalDeleteCommon>
          </div>
        );
      },
    }
  ];

  const handleRemove = (idDelete) => {
    const params = {
      action_type: "delete_slide_deck",
      id: idDelete,
    };
    dispatch(removeSlideDesk(params));
  };

  const contentTable = ({ paginationProps, paginationTableProps }) => (
    <React.Fragment>
      <ToolkitProvider
        keyField="id"
        data={listCase?.data || []}
        columns={columns}
        search
      >
        {(toolkitprops) => (
          <div>
            <div className="table-library__filter d-flex align-items-center justify-content-between">
              <p>Chatbot Monitoring</p>
              <WrapFilter>
                <SearchCustomForTable
                  toolkitprops={toolkitprops}
                  paginationProps={paginationProps}
                  isResetPagination
                  searchMode="auto"
                  placeholder={`Search`}
                />
                <ButtonComponent
                  size="small"
                  className="d-flex align-items-center btn-add-new"
                  onClick={() => toggle('newExperiment')}
                >
                  <Icon src={Plus} stroke="#fff" width={20} height={20}/>
                  <span>New Experiment</span>
                </ButtonComponent>
              </WrapFilter>
            </div>
            {console.log(toolkitprops)}
            <BootstrapTable
              condensed
              wrapperClasses="table-custom-common table-responsive mt-4"
              bordered={false}
              data={(listCase?.data && listCase?.data) || []}
              columns={columns}
              noDataIndication={() => (
                <MessageEmtyData 
                  title="No Results Found"
                  text="Sorry, we couldn't find any matches for your search. Please try adjusting your search terms or using different keywords."
                />
              )}
              {...paginationTableProps}
              {...toolkitprops.baseProps}
            />
          </div>
        )}
      </ToolkitProvider>
      <div className="pagination-custom-case d-flex justify-content-end mr-4 mb-4">
        <PaginationListStandalone {...paginationProps} />
      </div>
    </React.Fragment>
  );

  const totalSize = listCase?.data?.length || 0; // Dynamically determine the total size

  // Generate pagination configuration dynamically
  const paginationConfig = paginationOptions({ totalSize });
  return (
    <div className="table-library position-relative pt-0">
      {listCase?.isLoading ? (
        <div className="height-loader mt-5">
          <LoaderText />
        </div>
      ) : (
        listCase?.data?.length === 0 ? (
          <MessageEmtyData
            title="Your Library is Empty"
            text="It looks like you haven't generated any teaching slides yet. Start creating a new one to see it here."
          />
        ) : (
          <PaginationProvider pagination={paginationFactory(paginationConfig)}>
            {contentTable}
          </PaginationProvider>
        )
      )}
      {modal?.newExperiment &&
        <ModalNewExperiment
          {...props}
          isOpen={modal?.newExperiment}
          toggle={() => toggle('newExperiment')}
      />
      }
    </div>
  )
}

export default ChatbotTable
